import React from "react";
import {Button} from "reactstrap";
import ButtonDesign from "../../components/ButtonDesign";
import shareAvailability from "../../assets/images/share-availability.svg";

const ShareButtonComponent = (props) => {
    if (!props.icon) {
        return (
            <span className={"popover__wrapper"}>
            <Button outline color="primary" className="px-5 share-rectangle-with-icon">
              <img className="share-availability-icon mr-1" src={shareAvailability}/>
                Share
            </Button>
            <div className={"popover_share_content"} style={{bottom: "15px", right: "96px"}}>
              <ul className="popover_menucontent" aria-labelledby="myDropdown">
                {
                    props.shareList &&
                    props.shareList.map((shareData,index) => {
                            return (
                                <li style={{display: "inline-block"}} key={`share-key-${index}`}>
                                    <a>{shareData}</a>
                                </li>
                            );
                        }
                    )
                }
              </ul>
            </div>
        </span>
        )
    } else {
        return (
            <span className={"popover__wrapper"}>
                <ButtonDesign
                    btColor="light"
                    btClass="bg-white mx-2 rounded-0 heartbtn btn-with-shadow btn-with-icon"
                    onclickFunction={() => {}}>
                  <img className="share-availability-icon" src={shareAvailability}/>
                </ButtonDesign>
                <div className={"popover_share_content"} style={{bottom: "15px", right: "140px"}}>
                  <ul className="popover_menucontent" aria-labelledby="myDropdown">
                    {
                        props.shareList &&
                        props.shareList.map((shareData,index) => {
                            return (
                                <li style={{display: "inline-block"}} key={`share-key-${index}`}>
                                    <a>{shareData}</a>
                                </li>
                            )
                        })
                    }
                  </ul>
                </div>
            </span>
        )
    }
};

export default ShareButtonComponent;